import postCard from '../modules/post-card';

export default {
    init() {},
    finalize() {
        postCard();
    },
};
